import React, { Component } from 'react';
import { connect } from 'react-redux';
import * as Scenario from './Saga/Scenario';

import { Modal, ModalHeader, ModalFooter, ModalBody } from 'reactstrap';
// import * as Board from './Saga/Board';
import Draggable from 'react-draggable'; // The default
import Owner from '../Owner/Index';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import { TextField } from '@material-ui/core';
import Grid from '@material-ui/core/Grid';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import InputLabel from '@material-ui/core/InputLabel';
import FormControl from '@material-ui/core/FormControl';
import IconButton from '@material-ui/core/IconButton';
import AddCircleIcon from '@material-ui/icons/AddCircle';
import RemoveCircleIcon from '@material-ui/icons/RemoveCircle';
import ArrowCircleUpIcon from '@material-ui/icons/ArrowDropDownCircle';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import Tooltip from '@material-ui/core/Tooltip';
import Checkbox from '@material-ui/core/Checkbox';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Chip from '@material-ui/core/Chip';
import { stat } from 'fs';


let delete_list = []

function fncDeleteSelect(room_support_chat_template_list, id, status) {
    // alert(id + "-" + status)
    let new_room_support_chat_template_list = room_support_chat_template_list

    new_room_support_chat_template_list = new_room_support_chat_template_list.map(function (value) {
        if (value.id == id && value.status == status) {
            // alert(value["contents"].filter(a => a["type"] == "select").length)
            if(value["contents"].filter(a => a["type"] == "select").length > 0){
                
                value["contents"].filter(a => a["type"] == "select")[0]["actions"].map(function (value2) {   
                    let data_tmp2 = value2["data"]
                    let label_tmp2 = value2["label"]
                    if(label_tmp2 != "前の質問に戻る"){
                        // alert(data_tmp2)
                        // alert(label_tmp2)
                        fncDeleteSelect(new_room_support_chat_template_list, data_tmp2.split("-")[0], data_tmp2.split("-")[1])

                    }
                    
                })
                // value["contents"][key]["actions"].splice(contents_key, 1)

            }
        }
        return value
    })

    // 削除
    // let delete_key = 0
    // room_support_chat_template_list = room_support_chat_template_list.map(function (value, key) {
    //     if (value.id == id && value.status == status) {
    //         delete_key = key
    //         // alert(value["contents"].filter(a => a["type"] == "select").length)
    //         // value["contents"][key]["actions"].splice(contents_key, 1)
    //     }
    //     return value
    // })
    // alert(delete_key)
    // room_support_chat_template_list.splice(delete_key, 1)

    delete_list.push(id + "-" + status)

    // console.log(new_room_support_chat_template_list)
    let result = new_room_support_chat_template_list.filter((a) => {
        // if(parseInt(a.id) == parseInt(id) && parseInt(a.status) == parseInt(status))alert(a.id)
        return !(parseInt(a.id) == parseInt(id) && parseInt(a.status) == parseInt(status));
    });
    // alert(result.length)
// alert(JSON.stringify(new_room_support_chat_template_list))
// alert(result)
    // console.log(id + "-" + status)
    // console.log("bbbbbbbbbbbbb")
    // console.log(result)

    return result

    // new_room_support_chat_template_list = result

    // change_room_support_chat_template_list(new_room_support_chat_template_list)



}




class CardComponent extends Component{

    constructor(props) {
        super(props);

        this.state = {
            refresh: false,
           
        }
        // alert(JSON.stringify(this.props.room_support_chat_template_list))

        this.onDelete = this.onDelete.bind(this);
        this.onAdd = this.onAdd.bind(this);
        this.onChangeName = this.onChangeName.bind(this);
        this.onChangeText = this.onChangeText.bind(this);
        this.onChangeLabel = this.onChangeLabel.bind(this);
        this.onChangeType = this.onChangeType.bind(this);
        this.onChangeOutai = this.onChangeOutai.bind(this);
        this.onChangeSelected = this.onChangeSelected.bind(this);
        this.onAddSelect = this.onAddSelect.bind(this);
        this.onAddSelectRe = this.onAddSelectRe.bind(this);
        this.onDeleteSelect = this.onDeleteSelect.bind(this);
        this.onAddSelectNext = this.onAddSelectNext.bind(this);//つかってない
        this.onSelectChip = this.onSelectChip.bind(this);

    }





    componentWillMount() {
        // this.props.get_kyousais()
        // this.props.customerNewDispSet(0)
        // this.submit = this.submit.bind(this);
    }
    //     aa(state:any){
    // console.log(state)
    //     }


    csv() {

        // this.props.get_rent_contract_accounting(this.props.kyousais);
    }

    onDelete(id, status, key){
        // alert("onDelete")
        let room_support_chat_template_list = this.props.room_support_chat_template_list

console.log(this.props.room_support_chat_template_list)
console.log("cccccccccccccccccccccccccc")

        // 一覧の情報更新
        room_support_chat_template_list = room_support_chat_template_list.map(function (value) {
            if (value.id == id && value.status === status) {
                


                if(value.contents[key]["type"] == "select"){
                    value.contents[key]["actions"].map(function (value2) {   
                        let data_tmp2 = value2["data"]
                        let label_tmp2 = value2["label"]
                        if(label_tmp2 != "前の質問に戻る"){
                            // alert(data_tmp2)
                            // alert(label_tmp2)
                            fncDeleteSelect(room_support_chat_template_list, data_tmp2.split("-")[0], data_tmp2.split("-")[1])
    
                        }
                        
                    })
                }






                value.contents.splice(key, 1)

            }
            return value
        })

        for(let i = 0; i < delete_list.length; i++){
            let result = room_support_chat_template_list.filter((a) => {
                return !(a.id == delete_list[i].split("-")[0] && a.status == delete_list[i].split("-")[1]);
            });
    
            room_support_chat_template_list = result
        }
        delete_list=[]
        this.props.change_room_support_chat_template_list(room_support_chat_template_list)

        this.setState({ reflesh: !this.state.reflesh })

    }

    onAdd(id, status, key){
// alert(id)
// alert(status)
// alert("onAdd")
// console.log(this.props.room_support_chat_template_list)
// console.log("cccccccccccccccccccccccccc")
        let room_support_chat_template_list = this.props.room_support_chat_template_list

        
        // 一覧の情報更新
        room_support_chat_template_list = room_support_chat_template_list.map(function (value) {
            if (value.id == id && value.status === status) {
                
                // value.contents.splice(key, 1)
                // value.contents.push({"type":"text","text":""})
                value.contents.splice(key + 1, 0, {"type":"text","text":""})

            }
            return value
        })

        this.props.change_room_support_chat_template_list(room_support_chat_template_list)

        this.setState({ reflesh: !this.state.reflesh })

    }

    onChangeName(e, id, status){
        // alert("onChangeName")
        let room_support_chat_template_list = this.props.room_support_chat_template_list

        // 一覧の情報更新
        room_support_chat_template_list = room_support_chat_template_list.map(function (value) {
            if (value.id == id && value.status === status) {
                
                value.name = e.target.value

            }
            return value
        })

        this.props.change_room_support_chat_template_list(room_support_chat_template_list)

        this.setState({ reflesh: !this.state.reflesh })

    }

    onChangeText(e, id, status, key, column){
        // alert("onChangeText")
        let room_support_chat_template_list = this.props.room_support_chat_template_list

        
        // 一覧の情報更新
        room_support_chat_template_list = room_support_chat_template_list.map(function (value) {
            if (value.id == id && value.status === status) {
                
                value.contents[key][column] = e.target.value

            }
            return value
        })

        this.props.change_room_support_chat_template_list(room_support_chat_template_list)

        this.setState({ reflesh: !this.state.reflesh })

    }

    onChangeLabel(e, id, status, key, contents_key){
        // alert("onChangeLabel")
        let room_support_chat_template_list = this.props.room_support_chat_template_list

        
        // 一覧の情報更新
        room_support_chat_template_list = room_support_chat_template_list.map(function (value) {
            if (value.id == id && value.status === status) {
                
                value.contents[key]["actions"][contents_key]["label"] = e.target.value

            }
            return value
        })

        this.props.change_room_support_chat_template_list(room_support_chat_template_list)

        this.setState({ reflesh: !this.state.reflesh })

    }

    onChangeOutai(e, id, status){
        // alert("onChangeType")
        let room_support_chat_template_list = this.props.room_support_chat_template_list
        let tmp = ""
        
        // 一覧の情報更新
        room_support_chat_template_list = room_support_chat_template_list.map(function (value) {
            if (value.id == id && value.status === status) {
                
                // value.contents[key]["type"] = e.target.value
                value[e.target.name] = e.target.value
                

            }
            return value
        })


        this.setState({ reflesh: !this.state.reflesh })

    }

    onChangeSelected(e, id, status){
        // alert("onChangeType")

        let room_support_chat_template_list = this.props.room_support_chat_template_list
        let tmp = ""
        
        // 一覧の情報更新
        room_support_chat_template_list = room_support_chat_template_list.map(function (value) {
            if (value.id == id && value.status === status) {
                // alert(value.selected)
                // value.contents[key]["type"] = e.target.value
                if(e.target.checked == true){
                    value.selected = 1
                    // value.main_outai_sub = 6 
                    value.editable = 0
                    value.next_room_support_chat_template_category_id = null
                }else{
                    value.selected = 0
                    // value.main_outai_sub = 0
                    value.editable = 1
                    value.next_room_support_chat_template_category_id = null
                }

            }
            return value
        })        

        this.setState({ reflesh: !this.state.reflesh })

    }

    onChangeType(e, id, status, key){
        // alert("onChangeType")
        let room_support_chat_template_list = this.props.room_support_chat_template_list
        let tmp = ""
        
        // 一覧の情報更新
        room_support_chat_template_list = room_support_chat_template_list.map(function (value) {
            if (value.id == id && value.status === status) {
                
                // value.contents[key]["type"] = e.target.value
                
                if(value.contents[key].type == "select"){
                    //以降削除
                    value.contents[key]["actions"].map(function (value2) {   
                        let data_tmp2 = value2["data"]
                        let label_tmp2 = value2["label"]
                        if(label_tmp2 != "前の質問に戻る"){
                            // alert(data_tmp2)
                            // alert(label_tmp2)
                            fncDeleteSelect(room_support_chat_template_list, data_tmp2.split("-")[0], data_tmp2.split("-")[1])
    
                        }
                        
                    })
                }


                if(e.target.value == "text"){
                    value.contents[key] = {"type":"text","text":""}
                }else if(e.target.value == "select"){
                    let max_id = Math.max.apply(null,room_support_chat_template_list.map(function(o){return o.id;}))
                    // alert(max_id)
                    value.contents[key] = {"type":"select","actions":[
                        {"type":"postback","label":"","data":String(max_id + 1) + '-1'},
                        ]
                    }

                    tmp = {id:parseInt(max_id + 1), status:1, room_support_chat_template_category_id:this.props.room_support_chat_template_category_id, name:"", contents:[{"type":"text","text":""}]}

                    value.contents.splice(key + 1)
                    
                }else if(e.target.value == "tel"){
                    value.contents[key] = {"type":"tel","tel":"%コールセンターTEL%"}
                }
                else if(e.target.value == "img"){
                    value.contents[key] = {"type":"img","img":""}
                }
                else if(e.target.value == "movie"){
                    value.contents[key] = {"type":"movie","youtube_id":""}
                }
                

            }
            return value
        },this)

        // alert(delete_list.length)
        for(let i = 0; i < delete_list.length; i++){
            let result = room_support_chat_template_list.filter((a) => {
                return !(a.id == delete_list[i].split("-")[0] && a.status == delete_list[i].split("-")[1]);
            });
    
            room_support_chat_template_list = result
        }
        delete_list=[]


        if(e.target.value == "select"){
            this.props.change_room_support_chat_template_list(room_support_chat_template_list.concat(tmp))
        }else{
            this.props.change_room_support_chat_template_list(room_support_chat_template_list)
        }
        

        this.setState({ reflesh: !this.state.reflesh })

    }

    onSelectChip(id, status, key, contents_key){
        // alert(len)
        // alert(status)
        // alert(key)
        // alert("onAddSelect")
        // console.log(this.props.room_support_chat_template_list)
        // console.log("cccccccccccccccccccccccccc")
        let room_support_chat_template_list = this.props.room_support_chat_template_list
        
        // alert(key)
        let set_id = 0
        let set_status = 0
        // 一覧の情報更新
        room_support_chat_template_list = room_support_chat_template_list.map(function (value) {
            if (value.id == id && value.status === status) {
                value["contents_key"] = contents_key
            }
            return value
        })

        // alert(JSON.stringify(tmp))
        this.props.change_room_support_chat_template_list(room_support_chat_template_list)

        
        this.setState({ reflesh: !this.state.reflesh })
        
    }

    onAddSelect(id, status, key, len){
        // alert(len)
        // alert(status)
        // alert(key)
        // alert("onAddSelect")
        // console.log(this.props.room_support_chat_template_list)
        // console.log("cccccccccccccccccccccccccc")
        let room_support_chat_template_list = this.props.room_support_chat_template_list
        
        // alert(key)
        let set_id = 0
        let set_status = 0
        // 一覧の情報更新
        room_support_chat_template_list = room_support_chat_template_list.map(function (value) {
            if (value.id == id && value.status === status) {
                
                
                let data_key = value["contents"][key]["actions"][len -1]["data"]
                // alert(data_key)
                set_id = data_key.split("-")[0]
                set_status = data_key.split("-")[1]
                
                // value["contents"][key]["actions"].push({"type":"postback","label":"","data": String(set_id) +  "-" + String(parseInt(set_status) + 1)})
                value["contents"][key]["actions"].splice(len, 0, {"type":"postback","label":"","data": String(set_id) +  "-" + String(parseInt(set_status) + 1)})
                
                value["contents_key"] = len
            }
            return value
        })



        let tmp = {id:parseInt(set_id), status:parseInt(set_status) + 1, room_support_chat_template_category_id:this.props.room_support_chat_template_category_id, name:"", editable:0, selected:0, main_outai_sub:0, next_room_support_chat_template_category_id:null, remarks:null, contents:[{"type":"text","text":""}]}
        
        // alert(JSON.stringify(tmp))
        this.props.change_room_support_chat_template_list(room_support_chat_template_list.concat(tmp))

        
        this.setState({ reflesh: !this.state.reflesh })
        
    }

    onAddSelectRe(id, status, key, pre_id, pre_status){

        // alert(key)

        let room_support_chat_template_list = this.props.room_support_chat_template_list
        
        // alert(key)
        let set_id = 0
        let set_status = 0
        // 一覧の情報更新
        room_support_chat_template_list = room_support_chat_template_list.map(function (value) {
            if (value.id == id && value.status === status) {

                
                    let data_key = value["contents"][key]["actions"][value["contents"][key]["actions"].length -1]["data"]
                    // alert(data_key)
                    set_id = data_key.split("-")[0]
                    set_status = data_key.split("-")[1]
                
                value["contents"][key]["actions"].push({"type":"postback","label":"前の質問に戻る","data": String(pre_id) +  "-" + String(parseInt(pre_status))})
                value["contents_key"] = value["contents"][key]["actions"].length-1
            }
            return value
        })



        let tmp = {id:parseInt(set_id), status:parseInt(set_status) + 1, room_support_chat_template_category_id:this.props.room_support_chat_template_category_id, name:"", contents:[{"type":"text","text":""}]}
        
        // alert(JSON.stringify(tmp))
        this.props.change_room_support_chat_template_list(room_support_chat_template_list.concat(tmp))

        
        this.setState({ reflesh: !this.state.reflesh })
        
    }

    onDeleteSelect(id, status, key, contents_key, label){
        // alert("onDeleteSelect")
        // alert(id)
        // alert(status)
        // alert(key)
        // alert(contents_key)





        // let room_support_chat_template_list = this.props.room_support_chat_template_list
        
        // let data_tmp = ""
                
        // // 一覧の情報更新
        // room_support_chat_template_list = room_support_chat_template_list.map(function (value) {
        //     if (value.id == id && value.status === status) {
        //         // alert(value["contents"][key]["actions"][contents_key]["data"])
        //         data_tmp = value["contents"][key]["actions"][contents_key]["data"]
        //         value["contents"][key]["actions"].splice(contents_key, 1)
        //     }
        //     return value
        // })

        // //一覧から削除　下の階層も
        // if(label != "前の質問に戻る"){
        //     let result = room_support_chat_template_list.filter((a) => {
        //         return !(a.id == data_tmp.split("-")[0] && a.status == data_tmp.split("-")[1]);
        //     });
    
        //     room_support_chat_template_list = result
        // }





        let room_support_chat_template_list = this.props.room_support_chat_template_list
        
        let data_tmp = ""
        let label_tmp = ""
                
        // 削除するレコードのdataとlabelを保存
        room_support_chat_template_list = room_support_chat_template_list.map(function (value) {
            if (value.id == id && value.status === status) {
                data_tmp = value["contents"][key]["actions"][contents_key]["data"]
                label_tmp = value["contents"][key]["actions"][contents_key]["label"]
                value["contents"][key]["actions"].splice(contents_key, 1)
            }
            return value
        })
        
        if(label_tmp != "前の質問に戻る" && data_tmp != ""){
            fncDeleteSelect(this.props.room_support_chat_template_list, data_tmp.split("-")[0], data_tmp.split("-")[1])
        }
        // while (data_tmp != ""){

        //     let id_tmp = data_tmp.split("-")[0]
        //     let status_id = data_tmp.split("-")[1]

        //     let data_tmp2 = ""
        //     let label_tmp2 = ""

        //     room_support_chat_template_list = room_support_chat_template_list.map(function (value) {                

        //         if (value.id == id_tmp && value.status === status_id) {
        //             if(value.filter(a=> a["type"] == "select").length > 0){
        //                 value.filter(a=> a["type"] == "select")[0]["actions"].map(function (value2) {   
        //                     data_tmp2 = value2["data"]
        //                     label_tmp2 = value2["label"]


        //                     // value["contents"][key]["actions"].splice(contents_key, 1)
        //                 })
        //             }
                    
        //         }
        //         return value
        //     })

            

        //     // 本レコード削除


        //     data_tmp = ""

        // }

        
        // // 一覧の情報更新
        // room_support_chat_template_list = room_support_chat_template_list.map(function (value) {
        //     if (value.id == id && value.status === status) {
        //         data_tmp = value["contents"][key]["actions"][contents_key]["data"]
        //         label_tmp = value["contents"][key]["actions"][contents_key]["label"]
        //         value["contents"][key]["actions"].splice(contents_key, 1)
        //     }
        //     return value
        // })

        // //一覧から削除　下の階層も
        // if(label_tmp != "前の質問に戻る"){
            
        //     let result = room_support_chat_template_list.filter((a) => {
        //         return !(a.id == data_tmp.split("-")[0] && a.status == data_tmp.split("-")[1]);
        //     });
    
        //     room_support_chat_template_list = result
        // }


        // 下に行きつくまで削除

        // id statusで検索してその中にselectがあったらそれぞれの削除


        // this.props.change_room_support_chat_template_list(room_support_chat_template_list)
        
        console.log("delete_list")
        console.log(delete_list)

        for(let i = 0; i < delete_list.length; i++){
            let result = room_support_chat_template_list.filter((a) => {
                return !(a.id == delete_list[i].split("-")[0] && a.status == delete_list[i].split("-")[1]);
            });
    
            room_support_chat_template_list = result
        }
        console.log(room_support_chat_template_list)
        delete_list=[]
        this.props.change_room_support_chat_template_list(room_support_chat_template_list)


        this.setState({ reflesh: !this.state.reflesh })
        
    }

    
    
    onAddSelectNext(data){ // 使ってない
        // alert("onAddSelectNext")
        let room_support_chat_template_list = this.props.room_support_chat_template_list

        // let max_id = Math.max.apply(null,room_support_chat_template_list.map(function(o){return o.id;}))
        
        // alert(data)
        let tmp = {id:parseInt(data.split("-")[0]), status:parseInt(data.split("-")[1]), room_support_chat_template_category_id:this.props.room_support_chat_template_category_id, name:"ああ", contents:[{"type":"text","text":""}]}
        
        // alert(JSON.stringify(tmp))
        this.props.change_room_support_chat_template_list(room_support_chat_template_list.concat(tmp))
        
        this.setState({ reflesh: !this.state.reflesh })
        
    }

    onChangeDisp(id, status){ 
        // alert("onAddSelectNext")
        let room_support_chat_template_list = this.props.room_support_chat_template_list

        // 一覧の情報更新
        room_support_chat_template_list = room_support_chat_template_list.map(function (value) {
            if (value.id == id && value.status === status) {

                value.disp = value.disp == null || value.disp == true ? false : true
            // alert(value.disp)
            }
            return value
        })

        this.props.change_room_support_chat_template_list(room_support_chat_template_list)
        
        this.setState({ reflesh: !this.state.reflesh })
        
    }

    render() {
        let type = ""
        return (

            <Card style={{backgroundColor:"#f5f5f5", display:'inline-block', marginLeft:15, marginTop:5, marginRight:15}}>
                {this.props.card_data.contents.length > 0 ? <CardContent>
                    {/* {this.props.card_data.name} */}
                    <Card style={{marginBottom:5, width:300}}><CardContent>
                        <TextField size="small" fullWidth value={this.props.card_data.name} id="search" onChange={(e) => this.onChangeName(e, this.props.card_data.id, this.props.card_data.status)} label="タイトル" name="search" variant="outlined" InputLabelProps={{ shrink: true }} />
                        {/* <Tooltip title={"リクエストに追加"}> */}
                            <FormControlLabel label="自動応答終了" style={{ marginLeft:0, marginTop:10}} control={<Checkbox name="selected" value={true} checked={this.props.card_data.selected == 1 ? true : false} onChange={(e) => this.onChangeSelected(e, this.props.card_data.id, this.props.card_data.status)} style={{ transform: "scale(1.0)" }} color="primary" />} />
                        {/* </Tooltip> */}
                        
                        
                        {this.props.card_data.selected == 1 ? <FormControl style={{ width: 100 }}>
                            <InputLabel  id="demo-simple-select-label">編集</InputLabel>
                        <Select
                            labelId="demo-simple-select-label"
                            id="demo-simple-select"
                            name="editable"
                            value={this.props.card_data.editable}
                            style={{marginLeft:5}}
                            label="編集"
                            onChange={(e) => this.onChangeOutai(e, this.props.card_data.id, this.props.card_data.status)}
                        >
                            <MenuItem value={0} >編集可({0})</MenuItem>
                            {this.props.card_data.selected == 0 ? <MenuItem value={1} >上記手順({1})</MenuItem>:""}
                            {/* <MenuItem value={1} >上記手順</MenuItem> */}
                            <MenuItem value={2} >完了({2})</MenuItem>
                        </Select>
                        </FormControl>:""}

                        {this.props.card_data.selected == 1 ? <FormControl style={{ width: 200, marginBottom:5 }}>
                            <InputLabel  id="demo-simple-select-label">フリー入力に対する返事</InputLabel>
                            <Select
                                labelId="demo-simple-select-label"
                                id="demo-simple-select"
                                name="next_room_support_chat_template_category_id"
                                value={this.props.card_data.next_room_support_chat_template_category_id}
                                style={{marginLeft:5}}
                                label="フリー"
                                InputLabelProps={{
                                    shrink: true,
                                }}
                                onChange={(e) => this.onChangeOutai(e, this.props.card_data.id, this.props.card_data.status)}

                            >

                                    <MenuItem value={null} >-</MenuItem>
                                {
                                    this.props.room_support_chat_template_category_list.filter(a=>Number(a.id) != Number(this.props.room_support_chat_template_category_id) && Number(a.id) != 1).map(function (value_cate) {
                                        return <MenuItem value={value_cate.id} >{value_cate.id}：{value_cate.name}</MenuItem>
                                    })
                                }
                            </Select>
                        </FormControl>:""}

                        <FormControl style={{ width: 200, marginLeft:5 }}>
                            <InputLabel  id="demo-simple-select-label">応対種別</InputLabel>
                            <Select
                                labelId="demo-simple-select-label"
                                id="demo-simple-select"
                                name="main_outai_sub"
                                value={this.props.card_data.main_outai_sub}
                                style={{marginBottom:10, marginLeft:5}}
                                label="応対種別"
                                // variant="filled"
                                // size="small"
                                // disabled={this.props.card_data.selected == 1 ? false:true}
                                // error = {this.props.card_data.selected == 1 && this.props.card_data.main_outai_sub == 0 ? true:false }
                                onChange={(e) => this.onChangeOutai(e, this.props.card_data.id, this.props.card_data.status)}
                            >
                                <MenuItem value={0} >-</MenuItem>
                                {
                                    this.props.tm_outai_sub_list && this.props.tm_outai_sub_list.map(function (value) {
                                        return <MenuItem value={value.id} > {value.name}</MenuItem>
                                    })
                                }
                            </Select>
                        </FormControl>
                    </CardContent>
                    </Card>

                    {this.props.card_data.contents.length > 0 ? this.props.card_data.contents.map(function (value, key) {
                
                        return <div>
                            <Tooltip title={"間に項目 追加"}><IconButton size="small" aria-label="add" onClick={() => this.onAdd(this.props.card_data.id, this.props.card_data.status, key -1 )}>
                            <AddCircleIcon style={{color:"orange"}} />
                        </IconButton></Tooltip>

                            <Card style={{marginBottom:5, width: value["type"] != "select" ? 300 : this.props.card_data.disp == false ? 100 : null}}><CardContent>
                        {/* {value["type"] == "select" ? <IconButton size="small" style={{marginLeft:5}} onClick={() => this.onChangeDisp(this.props.card_data.id, this.props.card_data.status)}>
                            {this.props.card_data.disp}
                            {this.props.card_data.disp == false ? <ArrowDropDownIcon style ={{transform:"rotate(270deg)"}}/> : <ArrowDropDownIcon style ={{transform:"rotate(90deg)"}} />}
                        </IconButton>:""} */}
                        <Select
                            labelId="demo-simple-select-label"
                            id="demo-simple-select"
                            name="type"
                            value={value["type"]}
                            style={{marginBottom:10}}
                            
                            onChange={(e) => this.onChangeType(e, this.props.card_data.id, this.props.card_data.status, key)}
                        >
                            <MenuItem value={"text"}>テキスト</MenuItem>
                            <MenuItem value={"select"}>選択肢 {this.props.card_data.id}-{this.props.card_data.status}</MenuItem>
                            <MenuItem value={"tel"}>TEL</MenuItem>
                            <MenuItem value={"img"}>画像</MenuItem>
                            <MenuItem value={"movie"}>youtube</MenuItem>

                        </Select>
                        {this.props.card_data.contents.length > 1 ? <Tooltip title={"項目 削除"}><IconButton size="small" aria-label="delete" onClick={() => this.onDelete(this.props.card_data.id, this.props.card_data.status, key)}>
                            <RemoveCircleIcon color="primary" />
                        </IconButton></Tooltip> : ""}
                        {(() => {
                        type = value["type"]
                        if(value["type"] == "text"){
                            return <div>
                            <TextField fullWidth size="small" value={value["text"]} id="search" onChange={(e) => this.onChangeText(e, this.props.card_data.id, this.props.card_data.status, key, "text")} label="テキスト" multiline rows="2" name="search" variant="outlined" InputLabelProps={{ shrink: true }} />
                            </div>
                        }else if(value["type"] == "img"){
                            return <div>
                            <TextField fullWidth size="small" value={value["img"]} id="search" onChange={(e) => this.onChangeText(e, this.props.card_data.id, this.props.card_data.status, key, "img")} label="ファイル名" name="search" variant="outlined" InputLabelProps={{ shrink: true }} />
                            </div>
                        }else if(value["type"] == "movie"){
                            return <div>
                            <TextField fullWidth size="small" value={value["youtube_id"]} id="search" onChange={(e) => this.onChangeText(e, this.props.card_data.id, this.props.card_data.status, key, "youtube_id")} label="youtube ID" name="search" variant="outlined" InputLabelProps={{ shrink: true }} />
                            </div>
                        }else if(value["type"] == "tel"){
                            return <div>
                                <TextField size="small" value={value["tel"]} id="search" onChange={(e) => this.onChangeText(e, this.props.card_data.id, this.props.card_data.status, key, "tel")} label="テキスト" name="search" variant="outlined" InputLabelProps={{ shrink: true }} />
                                </div>
                        
                        }else if(value["type"] == "select"){
                            return <div>

                            {value["actions"].map(function (contents_value, contents_key) {
                                return String(this.props.card_data.contents_key) == String(contents_key) ? <Chip label={contents_value["label"]} style={{backgroundColor:"#4caf50", color:"white"}} onClick={() => this.onSelectChip(this.props.card_data.id, this.props.card_data.status, key, contents_key)} /> : <Chip label={contents_value["label"]} variant={"outlined"} onClick={() => this.onSelectChip(this.props.card_data.id, this.props.card_data.status, key, contents_key)} />
                            },this)}

                            <div><Tooltip title={"選択肢 追加"}>
                            <IconButton size="small" aria-label="add" style={{height:27}} onClick={() => this.onAddSelect(this.props.card_data.id, this.props.card_data.status, key, value["actions"].filter(a=>a["label"] !== "前の質問に戻る").length)}>
                                <AddCircleIcon style={{height:21}} color="secondary" />
                            </IconButton>
                            </Tooltip>
                            {value["actions"].filter(a=>a["label"] == "前の質問に戻る").length == 0 && this.props.pre_card_data_id >= 0 ? <Tooltip title={"前の質問に戻る 追加"}>
                            <IconButton size="small" aria-label="add" style={{height:27}} onClick={() => this.onAddSelectRe(this.props.card_data.id, this.props.card_data.status, key, this.props.pre_card_data_id, this.props.pre_card_data_status)}>
                                <ArrowCircleUpIcon style={{ transform:"rotate(180deg)", color:"#4169e1", height:21}} />
                            </IconButton>
                            </Tooltip>:""}</div>
                            

                            <div  style={{display:'flex'}}>
                                    

                            {value["actions"].map(function (contents_value, contents_key) {
// alert(JSON.stringify(this.props.card_data))
// alert(contents_value)
// alert(this.props.room_support_chat_template_list.length)
                            if(String(this.props.card_data.contents_key) == String(contents_key)){

                                return <div><Card style={{marginRight:10, backgroundColor:contents_value["label"] == "前の質問に戻る" ? "#e1f0fa" : ""}}>
                                     {/* {JSON.stringify(this.props.room_support_chat_template_list)} */}
                                        <CardContent style={{minWidth:300}}>
                                            <TextField size="small" style={{width:240}} disabled = {contents_value["label"] == "前の質問に戻る" ? true : false} value={contents_value["label"]} onChange={(e) => this.onChangeLabel(e, this.props.card_data.id, this.props.card_data.status, key, contents_key)} id="search" label={"選択肢ラベル" + contents_value["data"]} name="search" variant="outlined" InputLabelProps={{ shrink: true }} />
                                            {value["actions"].filter(a=>a["label"] !== "前の質問に戻る").length > 1 || contents_value["label"] == "前の質問に戻る" ? <Tooltip title={"選択肢 削除"}><IconButton size="small" aria-label="delete" onClick={() => this.onDeleteSelect(this.props.card_data.id, this.props.card_data.status, key, contents_key, contents_value["label"])}>
                                                <RemoveCircleIcon color="secondary" />
                                            </IconButton></Tooltip>:""}
                                        </CardContent>
                                        {/* {console.log("ggggggggggg")}
                                            {console.log(contents_value["data"])}
                                            {console.log(parseInt(contents_value["data"].split('-')[0]))}
                                            {console.log(parseInt(contents_value["data"].split('-')[1]))}
                                            {this.props.room_support_chat_template_list?console.log( this.props.room_support_chat_template_list.filter(a => a.id == 1).length):""} */}
                                        {this.props.room_support_chat_template_list && contents_value["label"] != "前の質問に戻る" ? <CardComponent 
                                        room_support_chat_template_list ={this.props.room_support_chat_template_list} 
                                        change_room_support_chat_template_list = {this.props.change_room_support_chat_template_list} 
                                        tm_outai_sub_list = {this.props.tm_outai_sub_list} 
                                        room_support_chat_template_category_list = {this.props.room_support_chat_template_category_list} 
                                        key={contents_key} 
                                        room_support_chat_template_category_id={this.props.room_support_chat_template_category_id} 
                                        pre_card_data_id = {this.props.card_data.id} 
                                        pre_card_data_status = {this.props.card_data.status} 
                                        card_data = {this.props.room_support_chat_template_list && this.props.room_support_chat_template_list.filter(a => a.id == parseInt(contents_value["data"].split('-')[0]) && a.status == parseInt(contents_value["data"].split('-')[1])).length > 0 ? this.props.room_support_chat_template_list.filter(a => a.id == parseInt(contents_value["data"].split('-')[0]) && a.status == parseInt(contents_value["data"].split('-')[1]))[0] : ""} />
                                        :""}

                                        {/* {contents_value["label"] != "前の質問に戻る" ? <CardComponent card_data = {
                                            this.props.room_support_chat_template_list && this.props.room_support_chat_template_list.filter(a => a.id == parseInt(contents_value["data"].split('-')[0]) && a.status == parseInt(contents_value["data"].split('-')[1])).length > 0 ? this.props.room_support_chat_template_list.filter(a => a.id == parseInt(contents_value["data"].split('-')[0]) && a.status == parseInt(contents_value["data"].split('-')[1]))[0] : ""} /> : ""} */}
                                    </Card>
                                    {/* <IconButton size="small" aria-label="add" onClick={() => this.onAddSelectNext(contents_value["data"])}>
                                        <AddCircleIcon color="secondary" />
                                    </IconButton> */}
                                    </div>
                            }else{
                                return ""
                            }
                            },this)}

                            
                            </div>
                        </div>
                            
                        }

                        })()}
                        </CardContent></Card>
                        {/* {type != "select" ? <Tooltip title={"項目 追加"}><IconButton size="small" aria-label="add" onClick={() => this.onAdd(this.props.card_data.id, this.props.card_data.status, key)}>
                            <AddCircleIcon style={{color:"orange"}} />
                        </IconButton></Tooltip>:""} */}
                        </div>
                        
                    },this) : ""}
                    {type != "select" ? <Tooltip title={"項目 追加"}><IconButton size="small" aria-label="add" onClick={() => this.onAdd(this.props.card_data.id, this.props.card_data.status, this.props.card_data.contents.length-1)}>
                        <AddCircleIcon style={{color:"orange"}} />
                    </IconButton></Tooltip>:""}
                </CardContent >:""}
            </Card >

        );
    }
};


//export  default CustomerList;
const mapStateToProps = state => {
    return {
        // room_support_chat_template_list: state.scenario.room_support_chat_template_list,

        tm_outai_sub_list: state.scenario.tm_outai_sub_list,
        room_support_chat_template_category_list: state.scenario.room_support_chat_template_category_list,

    }
}
function mapDispatchToProps(dispatch) {
    return {

        change_room_support_chat_template_list(state) {
            dispatch(Scenario.change_room_support_chat_template_list(state))
        },
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(CardComponent);




